import React from 'react';
import Layout from '../../../../components/mui/Layout';
import SearchComponent from './components/SearchComponent';
import TableComponent from './components/TableComponent';
import ModalComponent from './components/ModalComponent';
import PermissionsComponent from './components/PermissionsComponent';

const UserPage = () => {
	
	return (
		<Layout.Page title="Usuarios">
			<SearchComponent />
			
			<TableComponent />
			
			<ModalComponent />
			
			<PermissionsComponent />
		</Layout.Page>
	);
};

export default UserPage;
